import { CanAccess } from '@refinedev/core'

import AccessDeniedPage from '@/pages/access-denied'

import ImagesPage from './list'

export default function ImagesRoute() {
  return (
    <CanAccess resource="images" action="list" fallback={<AccessDeniedPage />}>
      <ImagesPage />
    </CanAccess>
  )
}
